// router/authLoader.ts
import { redirect, LoaderFunctionArgs } from "react-router-dom";

/**
 * Auth loader pour les routes protégées.
 * Redirige vers /login si l'utilisateur n'est pas connecté.
 */
export function authLoader({ request }: LoaderFunctionArgs) {
    const token = localStorage.getItem("ACCESS_TOKEN");
    if (token) return null;

    const url = new URL(request.url);
    const next = encodeURIComponent(url.pathname + url.search);

    // Redirection vers /login avec le paramètre redirect
    // Le slug sera détecté automatiquement par Login.tsx via extractLoyaltySlug()
    throw redirect(`/login?redirect=${next}`);
}
